import { http } from '@/api/client/httpClient';
import type { AutoMapDto, AutoMapRequest, PaginatedOutput, UnderlyingDto, UpdateAutoMapDto } from '@/api/types/autoMap';

const BASE = '/api/app/auto-map';

export const autoMapApi = {
  getSymbolMappings: (input: AutoMapRequest) =>
    http.get<PaginatedOutput<AutoMapDto>>(`${BASE}/symbol-mappings`, { params: input }).then((r) => r.data),
  getDropdownData: (id: string) =>
    http.get<UnderlyingDto[]>(`${BASE}/${encodeURIComponent(id)}/dropdown-data`).then((r) => r.data),
  update: (input: UpdateAutoMapDto) => http.put<AutoMapDto>(BASE, input).then((r) => r.data),
  bulkUpdate: (rows: UpdateAutoMapDto[]) =>
    http.post<PaginatedOutput<AutoMapDto>>(`${BASE}/bulk-update`, rows).then((r) => r.data),
};
